import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { WeblinkFaultService } from '../shared/weblink-fault.service';
import { Jwt } from '../shared/jwt/jwt';
import { WeblinkUserService } from '../shared/weblink-user.service';
import {TranslateService} from "@ngx-translate/core";
import {dateToLocalDate} from "@docma-weblink/shared/common";


@Component({
  selector: 'app-weblink-main',
  templateUrl: './weblink-main.component.html',
  styleUrls: ['./weblink-main.component.scss']
})
export class WeblinkMainComponent implements OnInit {

  isLoading = true;
  hasToken: Boolean = false;
  hasValidToken: Boolean = false;
  tokenValidTo: Date;
  currentUser:string= null;
  token: string;
  jwt: Jwt;
  showLogin=false;

  tokenValidToMessage: String;

  constructor(private activatedRoute: ActivatedRoute,
              private weblinkService: WeblinkFaultService,
              private userService: WeblinkUserService,
              private translate: TranslateService) {

    this.currentUser= this.userService.getCurrentUser();
    this.userService.onUserChange.subscribe((u:string)=>{
      this.currentUser=u;
      this.showLogin= false;
    });

    }

  ngOnInit() {
    this.token = this.activatedRoute.snapshot.queryParams['t'];
    this.jwt = new Jwt(this.token);

    if (this.jwt && this.jwt.isValid) {
      this.hasToken = true;

      this.weblinkService.isValidToken(this.jwt).subscribe( result => {
          this.isLoading = false;
          this.hasValidToken = result.IsValid;
          this.tokenValidTo = result.ValidTo;
          this.tokenValidToMessage = this.translate.instant('weblink.main.tokenExpired1') + ' ' + (result.ValidTo ? dateToLocalDate(result.ValidTo.toString()) : '-') + ' ' + this.translate.instant('weblink.main.tokenExpired2');
      });
    } else {
      this.isLoading = false;
    }
  }
  changeUser(){
    this.showLogin= true;
  }
}
